import { createApp } from 'vue'
import App from './App.vue'
import './assets/main.css'

// Run settings are configured per answer path on the server; drop the retired
// client-side settings so nothing stale lingers in the browser.
try {
  localStorage.removeItem('jarvis.settings')
} catch {
  /* localStorage unavailable (private mode) */
}

createApp(App).mount('#app')
